/* eslint-disable no-console */
import debugFactory from "debug";

const debug = debugFactory( "teaming:common-vendor:fullstory" );

const IS_PROD_ENV = process.env.NODE_ENV === "production";

const MAX_RETRY_COUNT = 5;
const RETRY_INTERVAL = 1000;

let intervalHandle = null;
let isIdentified = false;

const disposeIntervalHandle = () => {
	if ( intervalHandle ) {
		clearInterval( intervalHandle );
		intervalHandle = null;
	}
};

export default function fullstoryTelemetryFactory() {
	return {
		/**
		 * @see https://help.fullstory.com/hc/en-us/articles/360020828113-FS-identify-Identifying-users
		 * @param {Object} user
		 * @param {String} user.personId
		 * @param {String} user.name
		 * @param {String} user.email
		 */
		identify( { personId, name, email, } ) {
			isIdentified = false;
			let tries = 0;
			disposeIntervalHandle();

			if ( !IS_PROD_ENV ) {
				isIdentified = true;
				return debug( "identify", { personId, name, email, } );
			}

			intervalHandle = setInterval( () => {
				if ( tries === MAX_RETRY_COUNT ) {
					disposeIntervalHandle();
					return console.warn( "FULLSTORY: identify", "timed out" );
				}

				tries += 1;

				// tag manager has not loaded FS yet
				if ( !window?.FS?.identify ) {
					return;
				}

				window.FS.identify( personId, {
					displayName: name,
					email,
				} );

				disposeIntervalHandle();
				isIdentified = true;
			}, RETRY_INTERVAL );
		},
		isIdentified() {
			return isIdentified;
		},
	};
}
